import { ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class TotalHoldingsLookup extends ModelBase {
    public brokerName: string = '';

    public total: number = 0;
}